/**
 * Embedded theme data for Questions Bar Widget
 *
 * Themes are stored as CSS strings and injected dynamically as <style> tags.
 * This keeps the widget self-contained with no external CSS file dependencies.
 */

// Autoblog theme - Dark blue theme
const autoblogTheme = `
gist-questions-bar-widget {
  --gist-questions-bar-background: #1a1a2e;
  --gist-questions-pill-background-split: #16213e;
  --gist-questions-pill-background-mixed: #3C3D3F;
  --gist-questions-pill-hover-background: #23252F;
  --gist-questions-pill-border-split: transparent;
  --gist-questions-pill-border-mixed: transparent;
  --gist-questions-pill-text-color: #ffffff;
  --gist-questions-ad-badge-color: #23252F;
  --gist-questions-ad-badge-background: #ffffff;
  --gist-questions-pill-focus-border-color: #ffffff;
  --gist-questions-pill-border-gradient: linear-gradient(var(--gist-questions-pill-background-mixed, #ffffff), var(--gist-questions-pill-background-mixed, #ffffff)) padding-box, linear-gradient(to right, #3C3D3F, #3C3D3F) border-box;
  --gist-questions-pill-border-gradient-hover: linear-gradient(var(--gist-questions-pill-hover-background, #ffffff), var(--gist-questions-pill-hover-background, #ffffff)) padding-box, linear-gradient(to right, #23252F, #23252F) border-box;
}
`;

// Localhost theme for development testing
const localhostTheme = `
gist-questions-bar-widget {
  --gist-questions-bar-background: #ffffff;
  --gist-questions-pill-background-split: #f8f8f8;
  --gist-questions-pill-background-mixed: #ffffff;
  --gist-questions-pill-hover-background: #C8DCF9;
  --gist-questions-pill-border-split: transparent;
  --gist-questions-pill-border-mixed: transparent;
  --gist-questions-pill-text-color: #1456B8;
  --gist-questions-ad-badge-color: #1456B8;
  --gist-questions-ad-badge-background: transparent;
  --gist-questions-pill-focus-border-color: #6A86F9;
  /* Gradient border for mixed mode pills (left to right: #C25D97 -> #FF6655 -> #6986F9) */
  --gist-questions-pill-border-gradient: linear-gradient(var(--gist-questions-pill-background-mixed, #ffffff), var(--gist-questions-pill-background-mixed, #ffffff)) padding-box, linear-gradient(to right, #C25D97, #FF6655, #6986F9) border-box;
  --gist-questions-pill-border-gradient-hover: linear-gradient(var(--gist-questions-pill-hover-background, #e8e8e8), var(--gist-questions-pill-hover-background, #e8e8e8)) padding-box, linear-gradient(to right, #1456B8) border-box;
}
`;

// Boing Boing theme - Clean white with orange accents
const boingboingTheme = `
gist-questions-bar-widget {
  --gist-questions-bar-background: #ffffff;
  --gist-questions-pill-background-split: #f8f8f8;
  --gist-questions-pill-background-mixed: #ffffff;
  --gist-questions-pill-hover-background: #C8DCF9;
  --gist-questions-pill-border-split: transparent;
  --gist-questions-pill-border-mixed: transparent;
  --gist-questions-pill-text-color: #1456B8;
  --gist-questions-ad-badge-color: #1456B8;
  --gist-questions-ad-badge-background: transparent;
  --gist-questions-pill-focus-border-color: #6A86F9;
  /* Gradient border for mixed mode pills (left to right: #C25D97 -> #FF6655 -> #6986F9) */
  --gist-questions-pill-border-gradient: linear-gradient(var(--gist-questions-pill-background-mixed, #ffffff), var(--gist-questions-pill-background-mixed, #ffffff)) padding-box, linear-gradient(to right, #C25D97, #FF6655, #6986F9) border-box;
  --gist-questions-pill-border-gradient-hover: linear-gradient(var(--gist-questions-pill-hover-background, #e8e8e8), var(--gist-questions-pill-hover-background, #e8e8e8)) padding-box, linear-gradient(to right, #C25D97, #FF6655, #6986F9) border-box;
}
`;

// Old default theme - Backup of original default colors before switch to boingboingTheme
const oldDefaultTheme = `
gist-questions-bar-widget {
  --gist-questions-bar-background: white;
  --gist-questions-pill-background-split: white;
  --gist-questions-pill-background-mixed: #f3f4f6;
  --gist-questions-pill-hover-background: #e5e7eb;
  --gist-questions-pill-border-split: transparent;
  --gist-questions-pill-border-mixed: transparent;
  --gist-questions-pill-text-color: #111827;
  --gist-questions-pill-focus-border-color: #6A86F9;
}
`;

// BizToc theme - Clean white with no shadow
const biztocTheme = `
gist-questions-bar-widget {
  --gist-questions-bar-shadow: none;
}
`;

/**
 * Map of theme names to CSS content
 */
export const THEMES = {
  'autoblog': autoblogTheme,
  'localhost': localhostTheme,
  'boingboing': boingboingTheme,
  'oldDefault': oldDefaultTheme,
  'biztoc': biztocTheme,
};

/**
 * Get CSS content for a theme
 * @param {string} themeName - Theme name
 * @returns {string|null} CSS content or null if theme not found
 */
export function getThemeCss(themeName) {
  return THEMES[themeName] || null;
}

/**
 * List all available theme names
 * @returns {string[]} Array of theme names
 */
export function getAvailableThemes() {
  return Object.keys(THEMES);
}
